declare global {
	interface Window {
		CookieConsentDialog: {
			updateVisibleFocusableElements(): void;
			buttonsDirection: string;
		};
	}
}

function getCookieConsentDialog(): Promise<Window['CookieConsentDialog']> {
	// If available, return it, otherwise wait for the global event
	return Promise.resolve(window.CookieConsentDialog ?? new Promise((resolve) => {
		window.addEventListener('CookieConsentOnDialogDisplay', () => resolve(getCookieConsentDialog()));
	}));
}

function safeUpdateFocusableElements(consentDialog: Window['CookieConsentDialog']): void {
	try {
		consentDialog.updateVisibleFocusableElements();
	} catch {
		// Cookiebot DOM not yet initialized or dialog was destroyed – ignore
	}
}

// This plugin fixes incorrect focus trap behavior in Cookiebot dialogs.
// The issue is that the inner state of the dialog buttons is not updated after calling sortBannerButtons.
// This results in the focus trap being set on the wrong button.
// The fix is to patch the buttonsDirection property, which calls updateVisibleFocusableElements on write.
// https://gitlab.com/apploud/globus-mujglobusweb/-/issues/2933
export default defineNuxtPlugin(() => {
	// Don't await this, don't block the app and other plugins
	getCookieConsentDialog().then((consentDialog) => {
		let {buttonsDirection} = consentDialog;

		// Update now
		safeUpdateFocusableElements(consentDialog);

		// Update on every change
		Object.defineProperty(consentDialog, 'buttonsDirection', {
			get: () => buttonsDirection,
			set(value: string) {
				buttonsDirection = value;
				setTimeout(() => safeUpdateFocusableElements(consentDialog));
			},
		});
	}).catch(() => {
		// CookieConsentDialog not available or initialization failed – do not surface as unhandled rejection
	});
});
